<script setup>
import { defineAsyncComponent, defineProps } from 'vue'

const Grape = defineAsyncComponent(
  () => import('@/components/basic/atoms/Grape.vue')
)

const props = defineProps({
  value: String
})
</script>

<template>
  <div class="pa-4 position-relative d-flex align-center justify-center">
    <Grape
      color="primary"
      class="position-absolute top-1 bottom-1 left-0 right-0"
    />
    <div
      class="position-relative text-white text-uppercase font-weight-bold d-flex flex-column align-center justify-center"
    >
      <span class="font-size-md-xxl font-size-s">
        {{ props.value }}
      </span>
      <span class="font-size-md-l font-size-xxs">
        {{ translate('checkout:savings') }}
      </span>
    </div>
  </div>
</template>
